import React from 'react'

export default function FilterIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <g clipPath="url(#clip0_2_378)">
            <path fillRule="evenodd" clipRule="evenodd" d="M3.20254 3.25C2.56666 3.25 2.21929 3.99165 2.62638 4.48013L7.72846 10.6026C8.06544 11.007 8.25001 11.5167 8.25001 12.0431V15.25C8.25001 15.4861 8.36109 15.7083 8.55001 15.85L9.75002 16.75V12.0431C9.75002 11.5167 9.93451 11.007 10.2715 10.6026L15.3736 4.48013C15.7807 3.99165 15.4333 3.25 14.7974 3.25H3.20254ZM1.47404 5.44041C0.252806 3.97493 1.29491 1.75 3.20254 1.75H14.7974C16.7051 1.75 17.7472 3.97493 16.5259 5.44041L11.4238 11.5629C11.3115 11.6977 11.25 11.8677 11.25 12.0431V16.75C11.25 17.9861 9.83881 18.6917 8.85001 17.95L7.65001 17.05C7.08342 16.625 6.74998 15.9582 6.74998 15.25V12.0431C6.74998 11.8677 6.68847 11.6977 6.57615 11.5629L1.47404 5.44041Z" fill="black"/>
        </g>
        <defs>
            <clipPath id="clip0_2_378">
            <rect width="18" height="18" fill="white"/>
            </clipPath>
        </defs>
        </svg>
  )
}
